import React, { useState } from 'react';  
import Card from 'react-bootstrap/Card'
import Collapse from 'react-bootstrap/Collapse'
import Badge from 'react-bootstrap/Badge'
import Image from 'react-bootstrap/Image'
import TooltipButton from './TooltipButton.jsx'
import moment from 'moment';  

function LoggingCard(props) {  

	var [visible, setVisible] = useState(false)

	let hdr = ''

	//console.log("props.endDate:"+props.showDate)

	if (props.showDate === true) {
		hdr = < Card.Header style={{ paddingTop: "0px", paddingBottom: "0px" }}>{moment(props.data.startDate).format("DD MMMM YYYY")}</Card.Header>
	}

	let distanceBadge = ''
	if (props.data.distance !== 0) {
		var badgecontent = props.data.distance + " km"
		if (props.data.location !== undefined && props.data.location.length > 0)
			badgecontent = props.data.location + " - "+badgecontent
		distanceBadge = <Badge pill variant="primary">{badgecontent}</Badge>
	}

	let logsInHours = props.data.duration * 8
	if (props.showLogsInHours === true) {
		logsInHours = Math.round(logsInHours * 1000) / 1000
	}
		
	return (  
		<Card style={{ paddingTop: "0px", paddingBottom: "0px", backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
			{hdr}		
			<Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }} onClick={()=>{setVisible(!visible)}}>
				<Card.Title>{props.data.projectName}</Card.Title>
				<Card.Subtitle>{props.data.projectItemName}</Card.Subtitle>
				<Card.Text style={{ paddingBottom: "0px", marginBottom: "0px" }}>
					{props.showLogsInHours && props.showLogsInHours === true && (/*props.data.duration*8*/logsInHours + " h")}
					{(props.showLogsInHours===undefined || props.showLogsInHours===false) && (props.data.duration + " d")}
					{(props.data.comments && props.data.comments.length > 0 ? (" - " + props.data.comments):"")}
				</Card.Text>
				<div className="text-right"><sup>{distanceBadge}</sup></div>
			</Card.Body>
			<Collapse in={visible}>
				<div>
				<Card.Footer >
						<TooltipButton style={{ marginRight: "5px" }} variant="outline-light" tooltiptext="Delete" onClick={() => { props.deleteLog(props.data.logId) }} content={<Image alt="Delete" src="bin.png" style={{ width: "32px" }} />}/>
						<TooltipButton style={{ marginRight: "5px" }} variant="outline-light" tooltiptext="Copy" onClick={() => { props.copyLog(props.data.logId) }} content={<Image alt="Copy" src="duplicate.png" style={{ width: "32px" }} />}/>
							<TooltipButton variant="outline-light" tooltiptext="Edit" onClick={() => { props.editLog(props.data.logId) }} content={<Image alt="Edit" src="pencil.png" style={{ width: "32px" }} />}/>
				</Card.Footer>
				</div>
			</Collapse>
				
		</Card>
		    
      );  
    
}  

export default LoggingCard  
